<template>

  <div id="app">
    <van-row id="main-view">
      <router-view></router-view>
    </van-row>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return{

    }
  },
  methods:{
    getQueryVariable: function (variable) {
      let query = window.location.search.substring(1);
      let vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        let pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
      }
      return(false);
    }
  },
  mounted() {


  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh
}

.main-content {
  padding: 10px 20px 5px 20px;
  overflow-y: scroll;
}

.mt {
  font-size: 17px !important;
  font-weight: bold !important;
}

</style>
